<template>
    <div class="view-app" id="app">
        <transition enter-active-class="view-main animated adding fadeIn" leave-active-class="view-main animated adding fadeOut" keep-alive>
            <template v-if="$route.meta && $route.meta.keepAlive">
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </template>
            <template v-else>
                <router-view></router-view>
            </template>
        </transition>
        <transition enter-active-class="view-main animated adding fadeIn" leave-active-class="view-main animated adding fadeOut" keep-alive>
            <div class="app-message-container" v-show="!$store.state.appLoader && appMessage"><span>{{appMessage}}</span></div>
        </transition>
        <transition enter-active-class="view-main animated adding fadeIn" leave-active-class="view-main animated adding fadeOut" keep-alive>
            <div class="app-loader-main" v-show="$store.state.appLoaderShow">
                <div class="app-loader">
                    <div class="dot">
                        <div class="first"></div>
                    </div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
                <div class="app-message" v-show="$store.state.appLoaderShow && $store.state.appLoaderShow !== true"><span>{{$store.state.appLoaderShow}}</span></div>
            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        name: 'App',
        computed: {
            appMessage () {
                return this.$store.state.appMessage
            }
        },
        watch: {
            appMessage (value) {
                const that = this
                if (value) {
                    setTimeout(() => { that.$store.commit('onChangeAppMessage', '') }, 3500)
                }
            }
        }
    }
</script>
<style>
body,input,button,select,textarea,pre{font-family:"微软雅黑",Helvetica,STHeiti,Droid Sans Fallback;}
::-webkit-input-placeholder { /* WebKit browsers */ color: #CCCCCC; }
:-moz-placeholder{ /* Mozilla Firefox 4 to 18 */ color: #CCCCCC; }
::-moz-placeholder { /* Mozilla Firefox 19+ */ color: #CCCCCC; }
:-ms-input-placeholder { /* Internet Explorer 10+ */ color: #CCCCCC; }

@keyframes dotrotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
@keyframes dotscale {
  0%, 10% { width: 16px; height: 16px; margin-left: -8px;  margin-top: -4px; }
  50% { width: 8px; height: 8px; margin-left: -4px; margin-top: 0; }
  90%, 100% { width: 16px; height: 16px;  margin-left: -8px;  margin-top: -4px; }
}
.app-loader-main{ position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 100; background-color: rgba(255,255,255,0.5); text-align: center; font-size: 12px; }
.app-loader-main .app-loader { width: 60px; height: 60px; position: absolute; z-index: 100; top: 50%; left: 50%; margin-top: -30px; margin-left: -30px; }
.app-loader-main .app-loader .dot { position: absolute; top: 0; left: 0; width: 60px; height: 60px; animation: 1.7s dotrotate cubic-bezier(0.775, 0.005, 0.310, 1.000) infinite; }
.app-loader-main .app-loader .dot:nth-child(1) { animation-delay: 0.2s; }
.app-loader-main .app-loader .dot:nth-child(2) { animation-delay: 0.35s; }
.app-loader-main .app-loader .dot:nth-child(3) { animation-delay: 0.45s; }
.app-loader-main .app-loader .dot:nth-child(4) { animation-delay: 0.55s; }
.app-loader-main .app-loader .dot:after, .app-loader-main .app-loader .dot .first { content: ""; position: absolute; width: 8px; height: 8px; background: #02aff1; border-radius: 50%; left: 50%; margin-left: -4px; }
.app-loader-main .app-loader .dot .first { background: #02aff1; margin-top: -4px; animation: 1.7s dotscale cubic-bezier(0.775, 0.005, 0.310, 1.000) infinite; animation-delay: 0.2s; }
.app-loader-main .app-message{ width: 300px; line-height: 30px; position: absolute; top: 50%; left: 50%; margin-top: 35px; margin-left: -150px; }
.app-loader-main .app-message span{ display: inline-block; padding-right: 20px; padding-left: 20px; font-size: 12px; }
.app-message-container{ position: absolute; z-index: 99; height: 32px; line-height: 32px; text-align: center; top: 50%; right: 0; left: 0; margin-top: -16px; }
.app-message-container span{ display: inline-block; padding-right: 20px; padding-left: 20px; background-color: rgba(0,0,0,0.7); color: #FFF; font-size: 12px; }

.view-app { position: relative; width: 100%; height: 100%; perspective: 1200px; transform-style: preserve-3d; background-color: #F5F6FA; }
.view-main { transform: translate3d(0, 0, 0); }

.webuploader-container div, .webuploader-container input{ width: 100%!important; height: 100%!important; }
.app-screen-header-user{ justify-content: center; margin: 0 50px; }
.app-screen-header-user .user-head { width: 50px; }
.app-screen-header-user .user-avatar { width: 30px; height: 30px; border-radius: 50%; margin: 10px auto; background-color: #EBEBEB; overflow: hidden; }
.app-screen-header-user .user-avatar.avatar{ background-image: url(/static/images/icon-avatar.png); background-position: center; background-repeat: no-repeat; background-size: contain; }
.app-screen-header-user .user-avatar .user-avatar-img{ width: 100%; vertical-align: inherit; margin-bottom: 10px; }
.app-screen-header-user .user-name{ padding: 0 10px 0 0; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; }
.order-tag{ border: 1px solid #EB3C38; border-radius: 3px; padding: 2px 4px; color: #EB3C38; font-size: 12px; margin-right: 5px; }
.img-auto{ width: 100%; height: 100%; }
.text-bold{ font-weight: bold; }
.text-danger{ color: #EB3C38 !important; }
.text-success{ color: #3c763d !important; }
</style>



// WEBPACK FOOTER //
// src/App.vue